// Built lazily with the caller's `t` so the copy follows the active language
// (a module-level array would freeze in the language active at import time).
// Keys carry the `shell:` prefix explicitly so they resolve whatever namespace
// the passed `t` is bound to.
export default function getDefaultNotifications(t) {
    return [
        {
            id: 1,
            title: t("shell:notifications.defaults.welcome.title"),
            description: t("shell:notifications.defaults.welcome.description"),
            icon: "campaign",
            date: "2022-01-01",
            avatar: 'platform',
            category: 'updates',
            handler: {
                type: 'link',
                value: 'https://help.ginastee.com',
            }
        },
        {
            id: 2,
            title: t("shell:notifications.defaults.aiBuilder.title"),
            description: t("shell:notifications.defaults.aiBuilder.description"),
            icon: "campaign",
            date: "2022-01-01",
            avatar: 'ai',
            category: 'updates',
            handler: {
                type: 'link',
                value: 'https://builder.ginastee.com',
            }
        },
    ];
}
